import ReactionPopup from './ReactionPopup.component';

export default ReactionPopup;